

// || export default const user_gradient; if you wish

const user_gradient: string = "linear(to-r, purple.300, purple.400, purple.500)";


export default user_gradient;